import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { DATE_FIELDS, INCLUDES, LAYOUTS, WEEK_COUNTS } from './weeklyPlanUtils';

const Pick = ({ label, value, options, onChange, testId }) => (
  <div className="min-w-[170px] flex-1">
    <div className="text-[10px] uppercase tracking-wide text-muted-foreground mb-1">{label}</div>
    <Select value={String(value)} onValueChange={onChange}>
      <SelectTrigger className="h-8 text-xs" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={String(o.value)} className="text-xs" data-testid={`${testId}-${o.value}`}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const WeeklyPlanControls = ({ prefs, onChange }) => (
  <div className="flex flex-wrap gap-3" data-testid="weekly-plan-controls">
    <Pick label="Show" value={prefs.layout} options={LAYOUTS} onChange={(v) => onChange({ layout: v })} testId="wp-layout" />
    <Pick label="Day is set by" value={prefs.date_field} options={DATE_FIELDS} onChange={(v) => onChange({ date_field: v })} testId="wp-date-field" />
    <Pick label="Orders" value={prefs.include} options={INCLUDES} onChange={(v) => onChange({ include: v })} testId="wp-include" />
    <Pick label="Weeks" value={prefs.weeks}
      options={WEEK_COUNTS.map((n) => ({ value: n, label: n === 1 ? '1 week' : `${n} weeks` }))}
      onChange={(v) => onChange({ weeks: Number(v) })} testId="wp-weeks" />
  </div>
);
